import styled from 'styled-components';
import {coreStyles} from '../../styles/core/index.style';

export const Wrapper = styled.div`
  padding-top: ${coreStyles.padding.padding24};
  text-align: center;
`;

export const Link = styled.a`
  text-decoration: none;
`;




// WEBPACK FOOTER //
// ./components/FSArating/FSArating.style.js